// A contact who belongs to several communities keeps one global record - name,
// id number, birth date, gender, date of death. spUser_Upsert writes it only
// when it is called with their default community:
//
//   UPDATE mekomi.DBUser SET ... WHERE user_id = @UserId
//     AND ISNULL(DefaultCommunityID, @CommunityId) = @CommunityId
//
// so saving those fields from anywhere else is a no-op. The form locks them
// there rather than accepting edits the save silently drops.

// The form keys those fields are held under. Both spellings of the nickname are
// here because the form writes `nickname` and the save payload reads `nickName`.
export const GLOBAL_POPULATION_FIELDS = [
  'firstName', 'middleName', 'lastName', 'nickName', 'nickname',
  'identityNumber', 'birthDate', 'gender', 'isDead', 'deathDate',
]

/**
 * Whether the contact's global details are read-only in the community being
 * worked in. An unknown default community locks nothing: a contact read before
 * the field was returned, or one being created, must stay editable.
 */
export const isGlobalFieldsLocked = (
  defaultCommunityId: number | string | null | undefined,
  currentCommunityId: number | string | null | undefined,
): boolean =>
  defaultCommunityId != null &&
  currentCommunityId != null &&
  Number(defaultCommunityId) !== Number(currentCommunityId)
